import toast from "react-hot-toast";

export const autoLogout = (redirect = "/") => {
  try {
    localStorage.clear();
    sessionStorage.clear();
    toast.error("Session expired. Login again.");

    setTimeout(() => {
      window.location.replace(redirect);
    }, 500);
  } catch (err) {
    console.error("Admin Auto Logout:", err);
  }
};
